<template>
  <main class="how-it-works">
    <div class="row how-it-works-top">
      <div class="col-8 cloud-r">
        <h1>{{ getTranslations.home_home_how_it_works }}</h1>
      </div>
      <div class="col-4 treasure_island_simple">
        <img class="ti_jackpot no_anime"
             src="static/images/icon-jackpot.png">
      </div>
    </div>
    <!-- RANDOM WAVES -->
    <div class="row random_waves">
      <div class="col-lg-2">
        <span class="waves wave3"></span>
      </div>
      <div class="col-lg-8"></div>
      <div class="col-lg-2">
        <span class="waves wave4"></span>
      </div>
    </div>
    <!-- RANDOM WAVES END -->
    <div class="how-it-works__content">
      <div class="how-it-works__item how-it-works__item--green">
        <div class="row how-it-works__item__content">
          <div class="col-8 how-it-works__item__text">
            <h2>{{ getTranslations.home_home_how_it_works_register }}</h2>
            <p>{{ getTranslations.home_home_how_it_works_text }}</p>
          </div>
          <div class="col-4 how-it-works__item__image">
            <img src="static/images/icon-howitworks-register.png">
          </div>
        </div>
      </div>
      <div class="how-it-works__item how-it-works__item--green">
        <div class="row how-it-works__item__content">
          <div class="col-4 how-it-works__item__image">
            <img src="static/images/icon-howitworks-coin.png"
                 :alt="getTranslations.project_config_index_duel_get_started">
          </div>
          <div class="col-8 how-it-works__item__text">
            <h2>{{ getTranslations.home_home_how_it_works_unlock_coins }}</h2>
            <p>{{ getTranslations.home_home_how_it_works_unlock_coins_text }}</p>
          </div>
        </div>
      </div>
      <div class="how-it-works__item how-it-works__item--blue">
        <div class="row how-it-works__item__content">
          <div class="col-8 how-it-works__item__text">
            <h2>{{ getTranslations.home_home_how_it_works_play_game_and_win }}</h2>
            <p>{{ getTranslations.home_home_how_it_works_play_game_and_win_text }}</p>
          </div>
          <div class="col-4 how-it-works__item__image">
            <img src="static/images/icon-howitworks-play.png"
                 :alt="getTranslations.project_config_index_play_against_others">
          </div>
        </div>
      </div>
      <div class="how-it-works__item how-it-works__item--blue">
        <div class="row how-it-works__item__content">
          <div class="col-4 how-it-works__item__image">
            <img src="static/images/icon-howitworks-jackpot.png"
                 alt="">
          </div>
          <div class="col-8 how-it-works__item__text">
            <h2>{{ getTranslations.home_home_how_it_works_win_the_jackpot }}</h2>
            <p>{{ getTranslations.home_home_how_it_works_win_the_jackpot_text }}</p>
          </div>
        </div>
      </div>
      <div class="faq">
        <div class="faq__header">
          <h3>{{ getTranslations.components_how_it_works_frequently_asked_questions }}</h3>
        </div>
        <div class="faq__container">
          <ul class="accordion">
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_1 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_1_row_1 }}<a :href="'mailto:'+getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_faq_answer_1_email')">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_faq_answer_1_email')}}</a>{{ getTranslations.project_faq_answer_1_row_2 }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_2 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_2 }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_3 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_3 }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_4 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_4 }}<br><br>
                <ul>
                  <li>{{ getTranslations.project_faq_answer_4_bullet_1 }}</li>
                  <li>{{ getTranslations.project_faq_answer_4_bullet_2 }}</li>
                  <li>{{ getTranslations.project_faq_answer_4_bullet_3 }}</li>
                </ul>
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_5 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_5 }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_6 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_6 }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_7 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_7_row1 }}<br><br>
                {{ getTranslations.project_faq_answer_7_row2 }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_8 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_8 }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_9 }}</a>
              <div class="inner">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_faq_answer_9') }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_10 }}</a>
              <div class="inner">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_faq_answer_10') }}
              </div>
            </li>
            <li>
              <a class="toggle-accordion"
                 href="javascript:void(0);">{{ getTranslations.faq_question_11 }}</a>
              <div class="inner">
                {{ getTranslations.project_faq_answer_11 }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'how-it-works-loggedIn',
  data() {
    return {
      imageTop: '/ext/skin/top_icon.png',
    };
  },
  mounted() {
    /* eslint-disable */
    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(scroll > 500) {
        $('.goto-top').fadeIn();
      }
      else {
        $('.goto-top').fadeOut();
      }
    });
    this.$nextTick(() => {
      /* eslint-disable */
      // initAccordion
      $('.toggle-accordion').click(function(e) {
        e.preventDefault();
        var $this = $(this);
        $('.toggle-accordion').removeClass('show');

        if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.removeClass('show');
          $this.next().slideUp(350);
        } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.addClass('show');
          $this.next().slideToggle(350);
        }
      });
      /* eslint-enable */
    });
  },
  methods: {
    imageErrorHandler() {
      this.imageTop = 'static/images/top_icon.png';
    },
    checkTopButton() {
      /* eslint-disable */
      $(window).scrollTop(0);
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/HowItWorksLoggedIn.vue